/* import { useCallback, useEffect, useState } from 'react'; */
import { PropsWithPopup } from 'scbk-services';
import { AdditionalComponent, useRemoteIdvCheck } from 'scbk-shared-module';
import { DialogWrapper } from 'scbk-ui-web';

import { useTranslation } from 'react-i18next';
import type { RemoteIdvCheckInfo, RemoteIdvCheckParam } from 'scbk-shared-module';

interface Props extends PropsWithPopup {
  initParam: RemoteIdvCheckParam;
  onComplete: (remoteIdvCheckInfo: RemoteIdvCheckInfo) => void;
  onClose?: () => void;
}

const RemoteIdvCheckComponent: React.FC<Props> = ({
  isOpen,
  setOpen,
  onComplete,
  initParam,
  onClose,
}) => {
  const { t } = useTranslation();
  const { getCustInfo } = useRemoteIdvCheck();

  console.log('본인인증 팝업 param => ', JSON.stringify(initParam));

  const handleComplete = (remoteIdvCheckInfo: RemoteIdvCheckInfo) => {
    onComplete?.(remoteIdvCheckInfo);
    setOpen?.(false);
  };
  return (
    <DialogWrapper
      title={t('RemoteIdvCheckComponent.001', '휴대폰 본인인증')}
      open={isOpen}
      setOpen={setOpen}
      isFull={true}
      onClose={() => {
        onClose?.();
      }}
      dismissible={false}
      checkScroll
    >
      <div className="pb-[104px]">
        <AdditionalComponent
          authType={initParam.tagType || 'B'}
          transType=""
          mode="tab"
          onComplete={async () => {
            const result = (await getCustInfo({
              ...initParam,
              bizAuthFlag: 'Y',
            })) as RemoteIdvCheckInfo;

            if (result) {
              handleComplete(result);
            }
          }}
        />
      </div>
    </DialogWrapper>
  );
};

export default RemoteIdvCheckComponent;
